module.exports = __webpack_public_path__ + "img/sdg_es_(16).ee140bd1.png";